import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import AppRoutes from './AppRoutes';

import { getCustomer } from './services/customer.service';
import { authCallback, authSignIn } from './services/auth.service';

import { IDLE, SUCCEEDED } from './constants';
import Loading from './components/loading/loading.component';
import { isEmptyObject } from './utils/isEmptyObject';
import { setAuthToken } from './services/utils';

export const Auth = () => {
    useEffect(() => {
        const asyncSignIn = async () => await authSignIn();

        asyncSignIn();
    }, []);

    return <Loading />;
};

export const Callback = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { authStatus, authData } = useSelector((state) => state.auth);
    const { customerStatus, customerData } = useSelector(
        (state) => state.customer
    );

    useEffect(() => {
        if (authStatus === IDLE) {
            dispatch(authCallback());
        }
        if (authStatus === SUCCEEDED) {
            setAuthToken(authData);
            dispatch(getCustomer());
        }
    }, [dispatch, authStatus, authData]);

    useEffect(() => {
        if (customerStatus === SUCCEEDED && !isEmptyObject(customerData)) {
            return navigate('/home');
        }
    }, [navigate, customerStatus, customerData]);

    return <Loading />;
};

const App = () => {
    return (
        <Box
            sx={{
                height: '100vh',
                boxSizing: 'border-box',
            }}
        >
            <AppRoutes />
        </Box>
    );
};

export default App;
